import { useState } from "react";

export const TargetControl = ({ currentTarget, loading, onSetTarget }) => {
    const [target, setTarget] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        await onSetTarget(target);
        setTarget('');
    };

    return (
        <div className="bg-slate-800 p-3 rounded-lg border border-slate-700">
            <h2 className="text-sm font-semibold text-white mb-2">
                Daily Target
            </h2>

            <form onSubmit={handleSubmit}>
                <div className="mb-1.5">
                    <label className="block text-xs font-medium text-slate-300 mb-1">
                        Target (USD)
                    </label>
                    <input 
                        type="number"
                        step="0.01"
                        placeholder="Enter target" 
                        value={target} 
                        onChange={(e) => setTarget(e.target.value)}
                        required
                        className="w-full h-8 px-2 text-xs bg-slate-900 text-white border border-slate-700 rounded outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500"
                    />
                </div>
                
                <button 
                    type="submit"
                    disabled={loading}
                    className={`w-full py-1.5 text-xs font-medium text-white rounded transition-all ${
                        loading 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-purple-500 hover:bg-purple-600 cursor-pointer'
                    }`}
                >
                    {loading ? 'Setting...' : 'Set Target'}
                </button>
            </form>

            {currentTarget !== null && (
                <div className="mt-2 pt-2 border-t border-slate-700">
                    <div className="flex items-center justify-between text-xs">
                        <span className="text-slate-400">Current:</span>
                        <span className="font-semibold text-purple-400">
                            ${currentTarget}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};
